class DesygnerApi {
  #isEnterprise = false;

  constructor () {
    this.#isEnterprise = INKIVE.C.WHITE_LABEL_CONFIGURATION?.has_account_manager ?? false;
    this.baseUrl = INKIVE.C.API_URL;
  }

  getCredentials () {
    if (!CONFIG.credentials) return null;

    const { token, hash } = CONFIG.credentials;
    return Base64.encode(`${token}:${hash}`);
  }

  get (endpoint) {
    return this._processRequest('GET', endpoint);
  }

  put (endpoint, data) {
    return this._processRequest('PUT', endpoint, data);
  }

  patch (endpoint, data) {
    return this._processRequest('PATCH', endpoint, data);
  }

  post (endpoint, data) {
    return this._processRequest('POST', endpoint, data);
  }

  delete (endpoint) {
    return this._processRequest('DELETE', endpoint);
  }

  processBatch (urls, method = 'get') {
    const data = urls.map((url, i) => ({
      id: i,
      url: this.baseUrl + url,
      method,
      headers: {
        Authorization: 'Basic ' + this.getCredentials(),
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'Fetch',
        ...(this.#isEnterprise ? { 'X-Client-Type': 'enterprise' } : {})
      }
    }));

    return fetch(this.baseUrl + 'business/batch', {
      method: 'POST',
      headers: {
        Authorization: 'Basic ' + this.getCredentials(),
        'Content-Type': 'application/json',
        ...(this.#isEnterprise ? { 'X-Client-Type': 'enterprise' } : {})
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then(data => {
        data.forEach(item => {
          item.body = JSON.parse(item.body);
        });
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  async _processRequest (method, endpoint, data) {
    const headers = new Headers({
      Authorization: 'Basic ' + this.getCredentials(),
      'Content-Type': 'application/json'
    });

    if (this.#isEnterprise) {
      headers.append('X-Client-Type', 'enterprise');
    }

    const response = await fetch(this.baseUrl + endpoint, {
      method,
      headers,
      body: data ? JSON.stringify(data) : null
    });

    if (!response.ok) {
      throw response;
    }

    const responseData = await response.text();
    return responseData ? JSON.parse(responseData) : {};
  }

  getWithHeaders (endpoint) {
    const headers = new Headers({
      Authorization: 'Basic ' + this.getCredentials(),
      'Content-Type': 'application/json'
    });

    if (this.#isEnterprise) {
      headers.append('X-Client-Type', 'enterprise');
    }

    return fetch(this.baseUrl + endpoint, { headers })
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return Promise.all([response.json().catch(() => ({})), response.headers, response.status]);
      })
      .then(([data, headers, status]) => {
        return {
          data,
          headers: [...headers].reduce((acc, [header, value]) => acc.concat(`${header}: ${value}\r\n`), ''),
          status
        };
      })
      .catch(error => {
        throw error;
      });
  }
}

module.exports = new DesygnerApi();
